import { Injectable } from '@angular/core';
import { ICostTypeGroup } from '../models/cost-type-group.model';
import { ICostTypeGroupDetail } from '../models/cost-type-group-detail.model';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';

const BASE_URL: string = 'cost-type-group';

@Injectable({
    providedIn: 'root',
})
export class CostTypeGroupResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getAllCostTypeGroups(): Observable<ICostTypeGroupDetail[]> {
        return this.myCostAccountingRequestService.get(BASE_URL);
    }

    public createCostTypeGroup(costTypeGroup: ICostTypeGroup): Observable<ICostTypeGroupDetail> {
        return this.myCostAccountingRequestService.post(BASE_URL, costTypeGroup);
    }

    public updateCostTypeGroup(costTypeGroup: ICostTypeGroup): Observable<ICostTypeGroupDetail> {
        return this.myCostAccountingRequestService.put(`${BASE_URL}/${costTypeGroup.id}`, costTypeGroup);
    }

    public deleteCostTypeGroup(groupId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${groupId}`);
    }

    public assignCostTypeToGroup(groupId: number, costTypeId: number): Observable<ICostTypeGroupDetail> {
        return this.myCostAccountingRequestService.post(`${BASE_URL}/${groupId}/cost-types/${costTypeId}`, {});
    }

    public deleteGroupAssignment(groupId: number, costTypeId: number): Observable<ICostTypeGroupDetail> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${groupId}/cost-types/${costTypeId}`);
    }
}
